import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import { BookingDetailsSidebarComponent } from '@shared/components/booking-details-sidebar/booking-details-sidebar.component';
import { BookingAssigningTabComponent } from '@shared/components/booking-details-sidebar/tab-components/booking-assigning-tab/booking-assigning-tab.component';
import {
    BookingCustomerProfileTabComponent
} from '@shared/components/booking-details-sidebar/tab-components/booking-customer-profile-tab/booking-customer-profile-tab.component';
import { BookingDetailsTabComponent } from '@shared/components/booking-details-sidebar/tab-components/booking-details-tab/booking-details-tab.component';
import { BookingMessagesTabComponent } from '@shared/components/booking-details-sidebar/tab-components/booking-messages-tab/booking-messages-tab.component';
import { BookingPaymentTabComponent } from '@shared/components/booking-details-sidebar/tab-components/booking-payment-tab/booking-payment-tab.component';
import { BookingPeopleTabComponent } from '@shared/components/booking-details-sidebar/tab-components/booking-people-tab/booking-people-tab.component';
import { RideTimelineTabComponent } from '@shared/components/booking-details-sidebar/tab-components/booking-timeline-tab/booking-timeline-tab.component';
import { ForceAssignDialogComponent } from '@shared/components/force-assign-dialog/force-assign-dialog.component';
import { AntiFraudActionsComponent } from '@shared/components/anti-fraud-actions/anti-fraud-actions.component';
import { TabContainerComponent } from '@shared/components/tab-container/tab-container.component';
import { TabItemComponent } from '@shared/components/tab-container/tab-item/tab-item.component';
import { FormatCamelCasePipe, FormatCurrencyPipe, FormatDatePipe, TextTransformPipe } from '@shared/pipes';
import { XpKitModule } from '@shared/modules/xp-kit.module';
import { MessageService } from 'primeng/api';
import { AppMaterialModule } from '../..//app-material.module';
import { AppPrimengModule } from '../../app-primeng-module';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { PageNotFoundComponent } from '../components/page-not-found/page-not-found.component';
import { ReportCustomersComponent } from '../components/report-customers/report-customers.component';
import { ReportDriversComponent } from '../components/report-drivers/report-drivers.component';
import { ReportExportDownloadComponent } from '../components/report-export-download/report-export-download.component';
import { ReportExportEmailComponent } from '../components/report-export-email/report-export-email.component';
import { ReportRevenueComponent } from '../components/report-revenue/report-revenue.component';
import {
	RegistrationApplicationProgressV2Component
} from 'app/registration/v2/application-modal/registration-application-progress-v2.component';
import { ColumnSelectorComponent } from 'app/column-selector/column-selector.component';
import { SpinnerComponent } from '../components/spinner';
import { SuspendUserComponent } from '../components/customer/suspend-user/suspend-user.component';
import { XpressCalendarComponent } from 'app/components/xpress-calendar/xpress-calendar.component';
import { SideBarMenuComponent } from 'app/components/sidebar-menu';
import { ButtonIconComponent } from 'app/components/button-icon/button-icon.component';
import { SettingsComponent } from 'app/features/settings/components/settings/settings.component';
import { HomeSettingsComponent } from 'app/components/home';
import { PortalBreadcrumbComponent } from '../components/portal-breadcrumb/portal-breadcrumb.component';
import { DndDirective } from 'app/operator';
import { ConfirmModalComponent } from 'app/components/modals/confirm-modal/confirm-modal.component';
import { UploadDocumentModalComponent } from 'app/components/modals/upload-document-modal/upload-document-modal.component';
import { EditProfileDetailsComponent } from 'app/components/modals/edit-profile-details/edit-profile-details.component';
import { ChangePasswordComponent } from 'app/components/layout/xpress-topbar/profile/profile-detail/change-password/change-password.component';
import { DocumentImageComponent } from 'app/components/layout/xpress-topbar/profile/profile-detail/document-image/document-image.component';

@NgModule({
	declarations: [
		ConfirmationDialogComponent,
		PageNotFoundComponent,
		ReportDriversComponent,
		ReportExportDownloadComponent,
		ReportExportEmailComponent,
		ReportCustomersComponent,
		ReportRevenueComponent,
		TabContainerComponent,
		TabItemComponent,
		BookingDetailsSidebarComponent,
		BookingDetailsTabComponent,
		BookingPeopleTabComponent,
		BookingCustomerProfileTabComponent,
		BookingPaymentTabComponent,
		BookingMessagesTabComponent,
		RideTimelineTabComponent,
		BookingAssigningTabComponent,
		ForceAssignDialogComponent,
		AntiFraudActionsComponent,
		TextTransformPipe,
		FormatCurrencyPipe,
		FormatDatePipe,
		FormatCamelCasePipe,
		TabContainerComponent,
		TabItemComponent,
		RegistrationApplicationProgressV2Component,
		ColumnSelectorComponent,
		SpinnerComponent,
		SuspendUserComponent,
		XpressCalendarComponent,
		SideBarMenuComponent,
		ButtonIconComponent,
		SettingsComponent,
		HomeSettingsComponent,
		PortalBreadcrumbComponent,
		ConfirmModalComponent,
		UploadDocumentModalComponent,
		EditProfileDetailsComponent,
		ChangePasswordComponent,
		DocumentImageComponent
	],
    imports: [
        CommonModule,
        RouterModule,
        AppPrimengModule,
        FullCalendarModule,
        FormsModule,
        ReactiveFormsModule,
        AppMaterialModule,
        DndDirective,
        XpKitModule

    ],
	exports: [
		CommonModule,
		RouterModule,
		AppPrimengModule,
		FullCalendarModule,
		FormsModule,
		ReactiveFormsModule,
		ConfirmationDialogComponent,
		PageNotFoundComponent,
		ReportDriversComponent,
		AppMaterialModule,
		TabContainerComponent,
		TabItemComponent,
		BookingDetailsSidebarComponent,
		BookingDetailsTabComponent,
		BookingPeopleTabComponent,
		BookingCustomerProfileTabComponent,
		BookingPaymentTabComponent,
		BookingMessagesTabComponent,
		RideTimelineTabComponent,
		BookingAssigningTabComponent,
		ForceAssignDialogComponent,
		AntiFraudActionsComponent,
		AppMaterialModule,
		TabContainerComponent,
		TabItemComponent,
		TextTransformPipe,
		FormatCurrencyPipe,
		FormatDatePipe,
		FormatCamelCasePipe,
		SpinnerComponent,
		SuspendUserComponent,
		ColumnSelectorComponent,
		XpressCalendarComponent,
		SideBarMenuComponent,
		ButtonIconComponent,
		SettingsComponent,
		HomeSettingsComponent,
		PortalBreadcrumbComponent,
		RegistrationApplicationProgressV2Component,
		ConfirmModalComponent,
		UploadDocumentModalComponent,
		EditProfileDetailsComponent,
		ChangePasswordComponent,
		DocumentImageComponent
	],
	providers: [
		MessageService
	]
})
export class SharedModule { }
